import baseTheme from '@/styles/themes/base.css';
import lightTheme from '@/styles/themes/light.css';
import darkTheme from '@/styles/themes/dark.css';
import lbxLightTheme from '@/styles/themes/lbx-light.css';

export default (alias) => {
    let theme;
    switch (alias) {
    case 'dark':
        theme = darkTheme;
        break;
    case 'lbxlight':
        theme = lbxLightTheme;
        break;
    default:
        theme = lightTheme;
        break;
    }

    return {...baseTheme, ...theme};
};



// WEBPACK FOOTER //
// ./src/app/theme.js